export default () => {
    return `<div class="modal">
        <div class="modal__inner">
            <div class="modal__container">
                <div class="modal__action">
                    <div class="modal__action-close btn btn-text">
                        <span>Close</span>
                        <svg class="icon-svg icon-svg--outline ml-1">
                            <use class="times" xlink:href="#icon-times"></use>
                        </svg>
                    </div>
                </div>
                <div class="modal__header"></div>
                <div class="modal__body"></div>
                <div class="modal__footer"></div>
            </div>
        </div>
        
    </div>`
}